import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FreudMessageService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IContact } from 'app/interfaces/contact.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { IContactFollowUpInfo } from 'modules/contacts/interfaces/contact-follow-up.interface';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

@Component({
	selector: 'contact-follow-up',
	templateUrl: './contact-follow-up.component.html',
	styleUrls: ['./contact-follow-up.component.scss'],
})
export class ContactFollowUpComponent implements OnInit {
	@Input() contact: IContact | null;
	@Input() professionalId: string | null = null;

	@Output() goToPromptuaries = new EventEmitter<void>();

	contactFollowUpInfo: IContactFollowUpInfo;
	isLoading = true;
	hasErrors = false;
	constructor(
		public promptuaryService: PromptuaryService,
		public message: FreudMessageService,
		public translate: TranslateService,
		public atService: ActionTrackerService
	) {}

	ngOnInit(): void {
		this.getContactFollowUpInfo();
		this.callActionTracker();
	}

	getContactFollowUpInfo() {
		this.promptuaryService
			.getContactFollowUpInfo(this.contact.refUserId)
			.toPromise()
			.then((response) => {
				this.contactFollowUpInfo = response;
			})
			.catch((error) => {
				console.error(error);
				this.message.add({
					severity: 'error',
					summary: this.translate.instant('CONTACT.FOLLOW_UP.ERROR'),
					detail: null,
				});
				this.hasErrors = true;
			})
			.finally(() => {
				this.isLoading = false;
			});
	}

	callActionTracker() {
		this.atService.eventTracker(
			SCOPE_TYPE.Contact,
			SUBSCOPE_TYPE.FollowUp,
			ITEM_TYPE.Page,
			INTERACTION_TYPE.View,
			{}
		);
	}
}
